import { render, staticRenderFns } from "./FullDialogTipoUsuario.vue?vue&type=template&id=77c2e72e&"
import script from "./FullDialogTipoUsuario.vue?vue&type=script&lang=js&"
export * from "./FullDialogTipoUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports